<jft-create-tender-steps></jft-create-tender-steps>

<router-outlet></router-outlet>
